import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldProject from "../../fields3/generic/entity/project/project"
import {GroupedData} from "../../data-structures/group"
import FieldDate from "../../fields3/generic/datetime/date/date"
import {ColumnID, SystemColumnType} from "../../gd-modules/manager/columns/types"
import FieldProto from "../../fields3/proto/field-proto"

const baseConfig = [
    { fieldId: 'name',          label: 'Name',          type: FieldType.STRING,},
    { fieldId: 'projectId',     label: 'Project',       type: FieldType.PROJECT },

    { fieldId: 'startMoment',   label: 'Start date',    type: FieldType.DATE }
]

export default class MeetingFields extends FieldsCollection {

    // Quick access
    get name()      : FieldString { return this.get('name') as FieldString }
    get projectId() : FieldProject { return this.get('projectId') as FieldProject }

    get startDate() : FieldDate { return this.get('startMoment') as FieldDate }

    constructor() {
        const fieldsConfig = baseConfig
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.MEETING)
    }

    getByColumnId(columnId: ColumnID): FieldProto | undefined {

        const TaskFieldsColumnToFieldMap: Partial<Record<SystemColumnType, FieldProto | undefined>> = {
            [SystemColumnType.TITLE]    : this.name,
        }

        return TaskFieldsColumnToFieldMap[columnId as SystemColumnType]
    }

    structureFilterFields(customFields?: any[]): GroupedData {
        return [
            {
                value   : 'general',
                label   : 'General',
                type    : 'system',
                items   : [
                    this.name,
                    this.projectId,
                ]
            },
            {
                value  : 'dates',
                label  : 'Dates',
                type   : 'system',
                items  : [
                    this.startDate,
                ]
            },
        ]
    }
}